import {request} from "./client";

/** A broker's standalone listings (and, through the same rows, their project unit types). */

export const getDashboardStats = () => request("/broker/dashboard-stats");

export const getMyListings = () => request("/broker/properties");

export const getMyListing = (id) => request(`/broker/properties/${id}`);

export const createListing = (payload, {submit = false} = {}) =>
    request(`/broker/properties${submit ? "?submit=true" : ""}`, {method: "POST", body: payload});

export const updateListing = (id, payload) => request(`/broker/properties/${id}`, {method: "PUT", body: payload});

export const submitListing = (id) => request(`/broker/properties/${id}/submit`, {method: "POST"});

export const deleteListing = (id) => request(`/broker/properties/${id}`, {method: "DELETE"});

export const setListingVisibility = (id, active) =>
    request(`/broker/properties/${id}/visibility?active=${active}`, {method: "PATCH"});
